export default __webpack_public_path__ + "static/media/fail.f2054665.svg";